import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  noteToggle: false,
  notesList: [],
  workOrderID: 0,
  selectedNote: {},
  noteViewOnly: false,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  pagination: {
    perPage: 10
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'note',
      label: 'Note',
      aria: 'Note',
      width: '45%',
      numeric: true,
      sortable: true,
      searchable: true
    },
    {
      field: 'aspNetName',
      label: 'Author',
      width: '20%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      label: 'Created Date',
      width: '20%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
